import { ChevronRight } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import useFormatMessage from '@/hooks/useFormatMessage';

export default function FreeTextRow({
  id,
  query,
  highlighted,
  onSelect,
  onMouseEnter,
  asOption,
}) {
  const formatMessage = useFormatMessage();
  const trimmed = query?.trim();
  if (!trimmed) return null;

  return (
    <Box
      id={id}
      {...(asOption
        ? { role: 'option', 'aria-selected': highlighted, tabIndex: -1 }
        : {})}
      component="button"
      type="button"
      onClick={() => onSelect(trimmed)}
      onMouseEnter={onMouseEnter}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        width: '100%',
        minHeight: 56,
        px: 2,
        font: 'inherit',
        textAlign: 'left',
        cursor: 'pointer',
        border: 'none',
        borderTop: '1px solid',
        borderColor: 'grayscale.200',
        backgroundColor: highlighted ? 'action.hover' : 'grayscale.100',
        '&:hover': { backgroundColor: 'action.hover' },
      }}>
      <Typography variant="body2" sx={{ flexGrow: 1, color: 'text.primary' }}>
        {formatMessage('rental_request_flow_freetext_prompt')}{' '}
        <Box component="span" sx={{ color: 'primary.main', fontWeight: 500 }}>
          {formatMessage('rental_request_flow_freetext_action', {
            query: trimmed,
          })}
        </Box>
      </Typography>
      <ChevronRight fontSize="small" sx={{ color: 'primary.main' }} />
    </Box>
  );
}

FreeTextRow.propTypes = {
  id: PropTypes.string,
  query: PropTypes.string.isRequired,
  highlighted: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func,
  asOption: PropTypes.bool,
};

FreeTextRow.defaultProps = {
  highlighted: false,
  asOption: true,
};
